import { render, staticRenderFns } from "./EventCategoryContent.vue?vue&type=template&id=14633c6f"
import script from "./EventCategoryContent.vue?vue&type=script&lang=js"
export * from "./EventCategoryContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports